// Edit each paragraph and its mobile summary together. HTML links/emphasis are supported.
export const childhood = {
  "id": "panel-5",
  "type": "story",
  "title": "Childhood",
  "blocks": [
    {
      "heading": "Robotic competitions",
      "desktop": "Between 2015 and 2018, I took part in regional robotics competitions across Thailand, including the World Robotics Olympiad (<a href='https://wro-association.org/' target='_blank'>WRO</a>), which brings together students to solve LEGO Mindstorm challenges. The prompts ranged from building home appliance robots to tackling unpredictable terrain, pushing us to think creatively under pressure. These early years introduced me to the world of robotics: programming sensors, engineering moving parts, and the basics of robotic localisation. Our team won several regional prizes, and while we didn’t quite reach the international stage, the experience sparked a lasting passion for building and problem-solving.",
      "mobile": "From 2015 to 2018, I competed in robotics across Thailand, including <a href='https://wro-association.org/' target='_blank' rel='noopener noreferrer'>WRO</a> challenges. Our regional prizes sparked a lasting interest in building and problem-solving."
    },
    {
      "heading": "Introduction to programming",
      "desktop": "During my early robotics training, I began with block-based programming environments like LEGO Mindstorms NXT-G, which helped me grasp fundamental logic and control flow. As I took on more complex challenges, I transitioned to writing JavaScript scripts to directly control robot behaviour. A shift that gave me greater flexibility and precision. Learning JavaScript through robotics sparked my curiosity in applying it beyond physical machines, making the leap to web development feel natural. The language that once powered my robots soon became the tool I used to build interactive websites and creative digital experiences.",
      "mobile": "I progressed from LEGO Mindstorms block programming to JavaScript-controlled robots, which led me into web development."
    }
  ],
  "images": [
    {
      "src": "./info_images/childhoodRobot.jpeg",
      "alt": "Childhood Image 1",
      "caption": "Home appliance robot for WRO competition"
    },
    {
      "src": "./info_images/robotAssemblyChildhood.jpg",
      "alt": "Childhood Image 2",
      "caption": "Assembly of Robot with peers"
    }
  ],
  "videos": []
};
